import React from 'react';
import { useField } from 'react-final-form';

import { Stack, TextField, Typography } from '@mui/material';

type Props = {
  name: string;
};

type InternalTextFieldProps = {
  label: string;
  name: string;
};
function InternalTextField({ label, name }: InternalTextFieldProps) {
  const { value, onChange } = useField<number | null>(name).input;
  const handleChange: React.ChangeEventHandler<HTMLInputElement> = (ev) => {
    const value = parseInt(ev.target.value);
    if (isNaN(value)) {
      onChange(null);
    } else {
      onChange(value);
    }
  };
  return (
    <TextField
      fullWidth
      onChange={handleChange}
      value={value}
      variant="standard"
      label={label}
      placeholder="auto"
      size="small"
      InputProps={{
        endAdornment: (
          <Typography variant="body2" color="text.secondary">
            px
          </Typography>
        ),
      }}
    />
  );
}

export default function ImageDimensionsInput({ name }: Props) {
  return (
    <Stack direction="row" spacing={2}>
      <InternalTextField label="Width" name={`${name}.props.width`} />
      <InternalTextField label="Height" name={`${name}.props.height`} />
    </Stack>
  );
}
